import {appRoute} from '../../../app-route';
import {LangKeyType} from '../../../provider/locale/translation/type';
import {rootApiUrl} from '../../../service/api/api-const';
import {getFromLocalStorage} from '../../../util/local-storage';

import {
    ssoClientCodeStorageKey,
    ssoClientCodeStorageSchema,
    ssoLoginClientCodeQueryName,
    SsoLoginErrorEnum,
    ssoLoginErrorLangKeyMap,
    SsoLoginFormKeyEnum,
    SsoLoginFormType,
} from './sso-login-const';

// The backend stores client codes trimmed and in lower case.
export function normalizeSsoClientCode(clientCode: string): string {
    return clientCode.trim().toLowerCase();
}

// A browser navigation, not an XHR: the backend answers with a redirect to the client's identity provider.
// It goes through `rootApiUrl` because the gateway routes only `/op/api` of the cabinet host to the backend.
export function getSsoLoginUrl(clientCode: string): string {
    return `${rootApiUrl}/sso/login/?client=${encodeURIComponent(clientCode)}`;
}

export function getSsoLoginPagePath(clientCode: string): string {
    return `${appRoute.ssoLogin.path}?${ssoLoginClientCodeQueryName}=${encodeURIComponent(clientCode)}`;
}

// A code passed in the URL (e.g. right after registration) wins over the one remembered from the last sign-in.
export function getSsoLoginInitialValues(clientCodeFromUrl: string | null): SsoLoginFormType {
    return {
        [SsoLoginFormKeyEnum.ClientCode]:
            clientCodeFromUrl ?? getFromLocalStorage<string>(ssoClientCodeStorageKey, ssoClientCodeStorageSchema, ''),
    };
}

function isSsoLoginError(code: string): code is SsoLoginErrorEnum {
    return Object.values<string>(SsoLoginErrorEnum).includes(code);
}

export function getSsoLoginErrorLangKey(code: string): LangKeyType {
    return isSsoLoginError(code) ? ssoLoginErrorLangKeyMap[code] : 'PAGE__SSO_LOGIN__ERROR__UNKNOWN';
}
